const getValueFromLocalStorage = (key: string): string => {
  let value: string | null;
  try {
    value = localStorage.getItem(key)
  } catch (error) {
    value = '';
  }
  return value as string;
}

const ACCESS_TOKEN_KEY = 'access';
const REFRESH_TOKEN_KEY = 'refresh';

class TokenService {

  getLocalAccessToken() {
    return getValueFromLocalStorage(ACCESS_TOKEN_KEY);
  }

  getLocalRefreshToken() {
    return getValueFromLocalStorage(REFRESH_TOKEN_KEY);
  }

  updateLocalAccessToken(token: string) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  }

  updateLocalRefreshToken(token: string) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  }

  flush() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }

}

export default new TokenService();